import {
    configureStore,
    ThunkAction,
    Action,
    combineReducers,
    Reducer,
    Middleware,
} from "@reduxjs/toolkit";
import threadsSlice from "../features/chat/threadsSlice";
import sessionSlice from "../features/chat/sessionSlice";
import {chatApi} from "../features/chat/chatApi";
import {bffApi} from "../features/chat/bffApi";
import {dibAppApi} from "../dibAppApi/dibAppApi";
import forbiddenReducer from "../features/auth/forbiddenSlice";
import sessionAuthReducer from "../features/auth/sessionAuthSlice";
import {forbiddenMiddleware} from "./forbiddenMiddleware";
import {sessionGuardMiddleware} from "./sessionGuardMiddleware";

// --- Determine build mode ---
const isDevelopment = process.env.NODE_ENV !== "production";

// --- Base Reducers and Middleware (always included) ---
export const baseReducers: Record<string, Reducer> = {
    threads: threadsSlice,
    session: sessionSlice,
    [chatApi.reducerPath]: chatApi.reducer,
    [bffApi.reducerPath]: bffApi.reducer,
    [dibAppApi.reducerPath]: dibAppApi.reducer,
    forbidden: forbiddenReducer,
    sessionAuth: sessionAuthReducer,
};

export const baseMiddleware: Middleware[] = [
    chatApi.middleware,
    bffApi.middleware,
    dibAppApi.middleware,
    sessionGuardMiddleware,
    forbiddenMiddleware,
];

export const store = configureStore({
    reducer: baseReducers, // Use the dynamically built reducers object
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // Concatenate the dynamically built middleware array
            .concat(baseMiddleware),

    devTools: isDevelopment
        ? {
              trace: true,
              traceLimit: 25,
          }
        : false,
});

// --- Type definitions (adjust if necessary based on conditional features) ---
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
// RootState might need adjustment if you rely on types from conditional features elsewhere
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
